import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { prescriptionAPI } from "@/lib/prescription-api";
import { queryKeys, invalidateQueries } from "@/lib/query-keys";

export const useInvestigationSearch = (
  search: string,
  type: "lab_tests" | "imaging" | "others" | "" = ""
) => {
  return useQuery({
    queryKey: queryKeys.consultation.catalogs.investigationsSearch(
      search,
      type
    ),
    queryFn: () => prescriptionAPI.searchInvestigations(search, type),
    // Enable when: search has 2+ chars OR a specific type is selected (not "All")
    enabled: search.length >= 2 || type !== "",
    staleTime: 1000 * 60 * 5,
  });
};

export const useInvestigationAdvice = (
  appointmentId: string,
  consolidated: boolean = false
) => {
  return useQuery({
    queryKey: queryKeys.consultation.patientData.investigationAdvice(
      appointmentId,
      consolidated
    ),
    queryFn: () =>
      prescriptionAPI.getInvestigationAdvice(appointmentId, consolidated),
    enabled: !!appointmentId,
  });
};

export const useAddInvestigationAdvice = (appointmentId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (investigationItemId: number) =>
      prescriptionAPI.addInvestigationAdvice(
        appointmentId,
        investigationItemId
      ),
    onSuccess: () => {
      queryClient.invalidateQueries(
        invalidateQueries.patientInvestigationAdvice(appointmentId)
      );
    },
  });
};

export const useDeleteInvestigationAdviceItem = (appointmentId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (adviceItemId: string) =>
      prescriptionAPI.deleteInvestigationAdviceItem(
        appointmentId,
        adviceItemId
      ),
    onSuccess: () => {
      queryClient.invalidateQueries(
        invalidateQueries.patientInvestigationAdvice(appointmentId)
      );
    },
  });
};
